import { useQuery } from "@tanstack/react-query";

import { getFarmDocScanSummary } from "services";

import { GET_FARM_DOC_SCAN_SUMMARY } from "consts";

import { GetFarmDocScanSummaryResponse } from "models";

export const useGetFarmDocScanSummary = ({ farmId }: { farmId: string }) =>
  useQuery<GetFarmDocScanSummaryResponse>({
    queryKey: [GET_FARM_DOC_SCAN_SUMMARY, farmId],
    queryFn: async () => getFarmDocScanSummary({ farmId }),
    enabled: !!farmId,
    staleTime: 1000 * 60 * 5,
  });
